import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
    Button, Modal, Row, Col,
    FormGroup,
    Label,
    Input
 } from "reactstrap";
import { FileDropzone, MultipleDropzoneList } from '../../FileDropzone';
import PropTypes from 'prop-types';
import Loader from '../../loaders';
import api from "../../../services/api";

export default function EditorResidencyValidation(props) {
    const {
        data,
        onClose,
        onUpload,
    } = props;

    const [ loading, setLoading ] = useState(false);
    const [ itemInEdit, setItemInEdit ] = useState({...data, attachments: []});
    const [ documentType, setDocumentType ] = useState(null);

    useEffect(() => {
        setLoading(true);

        api.get(`lookup/CandidateDocumentType?filter=${"Residency Validation"}`)
            .then((response) => {
                const documentTypeList = [...response.data];

                if (!documentTypeList)
                {
                    setDocumentType(null);
                    return;
                }

                setDocumentType(documentTypeList[0]);
            })
            .catch((error) => {
                console.error({ error });
            })
            .finally(() => setLoading(false))
            ;

    }, []);
    
    const handleTextChanged = useCallback(({ target: { name, value } }) => {
        setItemInEdit({ ...itemInEdit, [name]: value });
    }, [itemInEdit]);

    const downloadAttachment = useCallback((type) => {
    }, []);

    const removeAttachment = useCallback((fileInfo) => {
        const newAttachments = [...itemInEdit.attachments];
        const removedItem = newAttachments.filter(a => a.candidateDocumentId === fileInfo.candidateDocumentId)[0];
        const removedIndex = newAttachments.indexOf(removedItem);
        newAttachments.splice(removedIndex, 1);
        // console.log({removedItem, removedIndex});

        if (removedItem.candidateDocumentId <= 0) {
            setItemInEdit({ ...itemInEdit, attachments: [...newAttachments] });
            return;
        }

        const deletedAttachments = itemInEdit.deletedAttachments && itemInEdit.deletedAttachments.length ? [...itemInEdit.deletedAttachments] : [];
        deletedAttachments.push(removedItem.recruitmentAttachmentId);
        // console.log({deletedAttachments});
        setItemInEdit({ ...itemInEdit, attachments: [...newAttachments], deletedAttachments: [...deletedAttachments] });
    }, [itemInEdit]);

    const files = useMemo(() => {
        if (itemInEdit?.attachments?.length > 0)
            return <MultipleDropzoneList
                idField="recruitmentAttachmentId"
                nameField="filename"
                sizeField="fileSizeInBytes"
                download={downloadAttachment}
                remove={removeAttachment}
                data={itemInEdit.attachments}
            />;

        return null;
    }, [itemInEdit]);

    const uploadDocuments = useCallback(() => {
        if (!onUpload || !itemInEdit?.attachments?.length)
        {
            onClose();
            return;
        }

        setLoading(true);
        onUpload(itemInEdit.attachments, itemInEdit?.residencyValidationNotes);
    }, [itemInEdit]);

    return (
        <Modal
            isOpen={true}
            className="modal-lg contract-dialog"
            modalClassName="db-example-modal-lg"
        >
        {
            loading && <Loader />
        }
            <div className="modal-header">
                <h5 className="modal-title">{`${data ? `${data.firstName} ${data.surname} - ` : ""}Residency Validation`}</h5>
                <button
                    aria-label="Close"
                    className="close"
                    onClick={onClose}
                    type="button"
                >
                    <span aria-hidden={true}><i className="fas fa-times-circle" /></span>
                </button>
            </div>
            <div className="modal-body">
                <div className="dialog-wrapper">
                    <div className="dialog-section">
                        <h5>Upload Validation Documents</h5><br/>
                        <h6 className="text-default">*Please upload Passport, VISA Grant Notice and VEVO</h6>
                        <div className="dialog-form">
                            <Row>
                                <Col lg={12}>
                                    <FileDropzone
                                        files={files}
                                        onDrop={([file]) => {
                                            const newAttachments = itemInEdit?.attachments ? [...itemInEdit.attachments] : [];
                                            const newIds = newAttachments?.filter(a => a.candidateDocumentId <= 0);
                                            if (newIds.length)
                                                newIds.sort((a, b) => parseInt(b.candidateDocumentId) - parseInt(a.candidateDocumentId));

                                            const newId = newIds.length ? newIds[0].candidateDocumentId - 1 : 0;
                                            const newData = {
                                                candidateId: itemInEdit.candidateId ?? 0,
                                                filename: file.name,
                                                file,
                                                documentTypeId: documentType?.lookupId,
                                                documentType: documentType,
                                            };
                                            newAttachments.push(newData);
                                            // console.log({file, newData, newAttachments});

                                            setItemInEdit({ ...itemInEdit, attachments: [...newAttachments] });
                                        }}
                                        maxFiles={0}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={12}>
                                    <FormGroup>
                                        <Label>
                                            Validation Notes
                                        </Label>
                                        <Input
                                            name="residencyValidationNotes"
                                            id="residencyValidationNotes"
                                            type="textarea"
                                            value={itemInEdit?.residencyValidationNotes ?? ""}
                                            onChange={handleTextChanged}
                                            rows={6}
                                            autoComplete="off"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12} className="d-flex align-items-end justify-content-start">
                                    <Row className={`w-100 m-0${!files ? " border-top pt-3 mt-3" : ""}`}>
                                        <Button className="w-100" color="default" onClick={uploadDocuments} disabled={(itemInEdit?.attachments?.length ?? 0) < 3 || !documentType}>Upload</Button>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

EditorResidencyValidation.propTypes = {
    data: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onUpload: PropTypes.func,
};
